import type { Address } from '@einwert/valuation-api-client'

import { assembleAssetTitle, joinDefinedStrings, ListCardInfo, tokens } from 'ComponentLibrary'
import { TextWithEllipsis } from 'ComponentLibrary/src/piazza/text'

export const AssetInfoCell = ({ address, customer_asset_reference }: { address: Address; customer_asset_reference?: string }) => {
    const assetTitle = assembleAssetTitle(address)
    const addressLineTwo = joinDefinedStrings([address.zip, address.city])

    return (
        <ListCardInfo style={{ width: 0, minWidth: 0, flex: '1 1 0' }}>
            {customer_asset_reference && (
                <TextWithEllipsis
                    tooltipText={`[${customer_asset_reference}]`}
                    typographyProps={{ variant: 'headline5', color: tokens.ColorTextDefault }}
                    fullWidth
                >
                    [{customer_asset_reference}]
                </TextWithEllipsis>
            )}
            <TextWithEllipsis tooltipText={assetTitle} typographyProps={{ variant: 'headline4', color: tokens.ColorTextBoldest }} fullWidth>
                {assetTitle}
            </TextWithEllipsis>
            {addressLineTwo && (
                <TextWithEllipsis
                    tooltipText={addressLineTwo}
                    typographyProps={{ variant: 'textS', color: tokens.ColorTextDefault }}
                    fullWidth
                >
                    {addressLineTwo}
                </TextWithEllipsis>
            )}
        </ListCardInfo>
    )
}
